import endpoints from '../endpoints.ts';
import api from '../api/index.ts';
import { MedAPI, MedRequest } from '../api/med.ts';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { WithPagination } from '../types/types.ts';

export const MED_QUERY_KEY = 'MED_QUERY_KEY';

const useReadOneById = (
  params: {
    medId: number | string;
    isEpcisGenerated: boolean;
  },
  options?: Partial<UseQueryOptions<MedAPI.Response.readOneById | null>>
) =>
  useQuery({
    queryKey: [MED_QUERY_KEY, endpoints.med.read.one.by.id(), params],
    queryFn: () => api.med.read.one.by.id(params),
    ...options,
  });

const useReadOneBySerialNumberPedigree = (
  params: MedRequest.ReadOneBySerialNumberPedigree,
  options?: Partial<
    UseQueryOptions<MedAPI.Response.ReadOneBySerialNumberPedigree | null>
  >
) =>
  useQuery({
    enabled: Boolean(params.serialNumber),
    queryKey: [
      MED_QUERY_KEY,
      endpoints.med.read.one.by.serialNumber.pedigree(),
      params.serialNumber,
    ],
    queryFn: () => api.med.read.one.by.serialNumber.pedigree(params),
    ...options,
  });

const useReadManyBySearch = (
  params: MedAPI.Request.ReadManyBySearch,
  options?: Partial<
    UseQueryOptions<WithPagination<MedAPI.Response.ReadOneBySerialNumberPedigree> | null>
  >
) =>
  useQuery({
    queryKey: [MED_QUERY_KEY, endpoints.med.read.many.by.search(), params],
    queryFn: () => api.med.read.many.by.search(params),
    ...options,
  });

const medQueryHooks = {
  useReadOneById,
  useReadOneBySerialNumberPedigree,
  useReadManyBySearch,
};

export default medQueryHooks;
